<div class="container" *ngIf="!isForm">
  <div class="grey-background" (click)="onClick($event)">
    <img [src]="icon_url" alt="" />
  </div>
  <label>{{ label }}</label>
</div>

<div class="container" *ngIf="isForm">
  <div
    class="grey-background"
    [ngClass]="control.value ? 'active-background' : ''"
    [formControl]="control"
    ngDefaultControl
    (click)="control.setValue(!control.value)"
  >
    <img [src]="control['rawValue'].icon_url" alt="" />
  </div>
  <span>{{ control["rawValue"].label }}</span>
</div>
